module.exports = ReactBootstrap;


//////////////////
// WEBPACK FOOTER
// external "ReactBootstrap"
// module id = 34
// module chunks = 0